import { render, staticRenderFns } from "./UserManagementList.vue?vue&type=template&id=897fac9c&"
import script from "./UserManagementList.vue?vue&type=script&lang=js&"
export * from "./UserManagementList.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementList.vue?vue&type=style&index=0&id=897fac9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports